import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Compras",
    items: [
      { label: "Ordenes de Compra",  icon: "fas fa-shopping-basket", href: "/ListadoOrdenesCompra",   perm: "menu_oc"      },
      { label: "Recepción",          icon: "fas fa-cart-plus",       href: "/ListadoCompras",         perm: "menu_compras" },
      { label: "Faltantes en Compras", icon: "fas fa-minus-circle",  href: "/ListadoComprasFaltante", perm: "menu_compras" },
      { label: "Devoluciones",       icon: "fas fa-undo-alt",        href: "/ListadoDevolucionesProveedores", perm: "menu_devolucionesProveedores" },
    ],
  },
  {
    title: "Reportes",
    items: [
      { label: "Reporte Telas",          icon: "fas fa-cut",       href: "/CorteDiario",                   perm: "menu_compras" },
      { label: "Reporte Compras Material", icon: "fas fa-cart-plus", href: "/ReporteComprasMaterial",      perm: "menu_compras" },
      { label: "Reporte OC Material",    icon: "fas fa-cart-plus", href: "/ReporteOrdenesComprasMaterial", perm: "menu_compras" },
    ],
  },
];

function BotonesCompras() {
  return (
    <MenuGrid
      title="Compras"
      subtitle="Órdenes de compra, recepción y reportes de material"
      icon="fas fa-truck"
      accent={{ color: "#f59e0b", bg: "#fffbeb" }}
      gate="menu_compras"
      sections={SECTIONS}
    />
  );
}

export default BotonesCompras;
